/* eslint-disable */

import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Typography from 'material-ui/Typography';
import { withStyles } from 'material-ui/styles';
import green from 'material-ui/colors/green';
import { CircularProgress } from 'material-ui/Progress';
import Grid from 'material-ui/Grid';
import Card, { CardMedia, CardContent } from 'material-ui/Card';
import { withRouter } from 'react-router';
import Dropzone from 'react-dropzone';
import moment from 'moment';
import Lottie from 'react-lottie';
import * as animationCheckSuccess from '../assets/lottie/check_success.json';
import * as animationCryingEmoji from '../assets/lottie/crying_emoji.json';
import * as animationEmptyBox from '../assets/lottie/empty_box.json';
import { translate } from 'react-i18next';
import headerVideoMp4 from '../assets/videos/winding-forest-road.mp4';
import headerVideoWebM from '../assets/videos/winding-forest-road.webm';
import { Row, Col } from 'react-flexbox-grid';
import teoLogo from '../assets/images/teoLogo2BlancV2.png';

import { checkPdfReport, resetCheckPdfReport } from '../actions';

const styles = theme => ({
  videoBg: {
    overflow: 'hidden',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    position: 'relative',
    width: '100%',
  },
  videoContent: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: -10000,
    objectFit: 'cover',
  },
  myHeroTitle: {
    color: '#ffffff',
    fontFamily:
      '"Inter-Regular", "Avenir", "Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 'bold',
    fontSize: 28,
  },
  myBaseline: {
    color: '#ffffff',
    fontFamily:
      '"Inter-Regular", "Avenir", "Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 'bold',
    fontSize: 14,
  },
  root: {
    display: 'flex',
    flexWrap: 'center',
  },
  margin: {
    margin: theme.spacing.unit,
  },
  withoutLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  textField: {
    flexBasis: 200,
  },
  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative',
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  mySubtitle: {
    color: '#0AA082',
    fontFamily: 'Inter-Regular',
    fontWeight: 'bold',
    fontSize: 12,
    textTransform: 'none',
  },
  myTitle: {
    color: '#1E2B38',
    fontFamily: 'Inter-Regular',
    fontWeight: 'bold',
    fontSize: 20,
    textTransform: 'none',
  },
});

class ReportCheck extends React.Component {
  static contextTypes = {
    router: PropTypes.func.isRequired,
  };

  componentDidMount = () => {
    this.props.resetCheckPdfReport();
  };

  onDrop = async file => {
    this.props.checkPdfReport(file);
  };

  renderReportDetails = () => {
    const {
      classes,
      loadingReport,
      currentReport,
      isReportAuthentic,
      t,
    } = this.props;

    const defaultOptionsSuccess = {
      loop: false,
      autoplay: true,
      animationData: animationCheckSuccess,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };

    const defaultOptionsFail = {
      loop: true,
      autoplay: true,
      animationData: animationCryingEmoji,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };

    if (loadingReport) {
      return (
        <Grid container spacing={24}>
          <Grid item xs={12} sm={24}>
            <Card className={classes.card}>
              <CardContent>
                <Typography className={classes.title} color="textSecondary">
                  <p>
                    <span className={classes.mySubtitleTitle}>
                      {t('Checking your report...')}
                    </span>
                  </p>
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      );
    }
    if (
      currentReport &&
      currentReport.certifier &&
      currentReport.fileHash &&
      currentReport.date &&
      isReportAuthentic === true
    ) {
      return (
        <Grid container spacing={24}>
          <Grid item xs={12} sm={24}>
            <Card className={classes.card}>
              <CardContent>
                <div>
                  <Lottie
                    options={defaultOptionsSuccess}
                    height={100}
                    width={100}
                  />
                  <span
                    style={{
                      fontWeight: 'bold',
                      color: '#00ca72',
                      fontFamily: 'Inter-Regular',
                    }}
                  >
                    {t('Ce rapport est authentique')}
                  </span>
                </div>
                <Typography
                  className={classes.title}
                  color="textSecondary"
                  style={{ fontFamily: 'Inter-Regular' }}
                >
                  <p>
                    <span style={{ fontWeight: 'bold' }}>
                      {t('Certifié pour')}{' '}
                    </span>{' '}
                    {currentReport.certifier}
                  </p>
                  <p>
                    <span style={{ fontWeight: 'bold' }}>
                      {t('En date du')}
                    </span>{' '}
                    {moment
                      .unix(currentReport.date)
                      .format('YYYY-MM-DD HH:mm:ss')}
                  </p>
                  <p>
                    <span style={{ fontWeight: 'bold' }}>
                      {t('Empreinte digitale')}{' '}
                    </span>{' '}
                    {currentReport.fileHash.replace('0x', '')}
                  </p>
                  <p>
                    {currentReport.transactionExplorerURL ? (
                      <a
                        target="_blank"
                        style={{ textDecoration: 'none' }}
                        href={currentReport.transactionExplorerURL}
                      >
                        <span
                          style={{
                            fontWeight: 'bold',
                            color: '#00ca72',
                            fontFamily: 'Inter-Regular',
                          }}
                        >
                          {t('Preuve Blockchain')}{' '}
                        </span>
                      </a>
                    ) : (
                      ''
                    )}
                  </p>
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      );
    }

    if (isReportAuthentic === false) {
      return (
        <Grid container spacing={24}>
          <Grid item xs={12} sm={24}>
            <Card className={classes.card}>
              <CardContent>
                <div>
                  <Lottie
                    options={defaultOptionsFail}
                    height={100}
                    width={100}
                  />
                </div>
                <Typography className={classes.title} color="textSecondary">
                  <p
                    style={{ fontWeight: 'bold', fontFamily: 'Inter-Regular' }}
                  >
                    {t('Désolé, nous ne pouvons pas trouver ce rapport')}
                  </p>
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      );
    }

    if (isReportAuthentic === null) {
      return (
        <Grid container spacing={24}>
          <Grid item xs={12} sm={24}>
            <Card className={classes.card}>
              <CardMedia
                className={classes.media}
                style={{
                  height: '1%',
                  width: '6%',
                  paddingTop: '10%',
                  display: 'block',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
                image={require('../assets/images/gifs/downloading.gif')}
              />
              <CardContent>
                <Typography className={classes.title} color="textSecondary">
                  <p
                    style={{ fontWeight: 'bold', fontFamily: 'Inter-Regular' }}
                  >
                    {t('Aucun rapport téléchargé')}
                  </p>
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      );
    }
  };

  renderHeaderContent() {
    const { classes } = this.props;

    let headerBackgroundImageValue =
      'linear-gradient(to bottom, rgba(103,60,143,1), rgba(103,60,143,0.9), rgba(103,60,143,0.8), rgba(103,60,143,0.7), rgba(78,119,199,0.6), rgba(52,178,255,0.5), rgba(255,255,255,0))';
    headerBackgroundImageValue = '';

    return (
      <div
        style={{
          backgroundImage: headerBackgroundImageValue,
          backgroundColor: 'rgba(0,0,0,0.3)',
          padding: 30,
        }}
      >
        <Row>
          <Col xs={12}>
            <Row>
              <Col xs={8} sm={6} md={6} lg={6}>
                <a
                  style={{ textDecoration: 'none', color: 'inherit' }}
                  href={'/'}
                >
                  <img src={teoLogo} style={{ height: 64 }} />
                </a>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row style={{ marginBottom: 30, marginTop: 20 }}>
          <Col xs={12}>
            <Row center="xs">
              <Col xs={8} sm={6} md={6} lg={6}>
                <span className={classes.myHeroTitle}>
                  Partagez avec vos clients l’impact sur <u>leurs</u> produits
                  de <u>votre</u> engagement pour l’environnement.
                </span>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row style={{ marginBottom: 30 }}>
          <Col xs={12}>
            <Row center="xs">
              <Col xs={8} sm={6} md={6} lg={6}>
                <span className={classes.myBaseline}>
                  Attributes estime et certifie votre impact carbone dans la
                  blockchain.
                </span>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }

  render() {
    const { classes, loadingReport, t } = this.props;

    return (
      <div>
        <div className={classes.videoBg}>
          <video
            key={headerVideoMp4}
            loop
            autoPlay
            muted
            className={classes.videoContent}
          >
            <source type="video/mp4" src={headerVideoMp4} />
            <source type="video/webm" src={headerVideoWebM} />
          </video>
          {this.renderHeaderContent()}
        </div>

        <div style={{ display: 'block', width: '100%' }}>
          <div style={{ width: '50%', float: 'left', display: 'inline-block' }}>
            <div
              className={classes.root}
              style={{
                justifyContent: 'center',
                flexWrap: 'nowrap',
                alignItems: 'center',
                alignContent: 'center',
                textAlign: 'center',
                display: 'inherit',
                marginTop: 30,
                height: '100vh',
                padding: 30,
              }}
            >
              <div style={{ width: '100%', clear: 'both' }}>
                <Typography variant="display1" gutterBottom>
                  <span className={classes.myTitle}>
                    {t('Vérifiez votre rapport')}
                  </span>
                </Typography>
                <Typography variant="body1" gutterBottom>
                  <span className={classes.mySubtitle}>
                    {t(
                      'Téléchargez votre rapport et vérifiez son authenticité.'
                    )}
                  </span>
                </Typography>
                <Dropzone
                  onDrop={this.onDrop.bind(this)}
                  style={{
                    width: '100%',
                    textAlign: 'center',
                    border: '2px #737373 dashed',
                    fontSize: 25,
                    height: '100%',
                    minHeight: 300,
                    marginTop: 30,
                    backgroundColor: 'rgba(255, 255, 255, .8)',
                  }}
                  className={classes.dropzone}
                  accept="application/pdf"
                  disableClick={false}
                >
                  <div
                    style={{
                      justifyContent: 'center',
                      flexWrap: 'nowrap',
                      alignItems: 'center',
                      alignContent: 'center',
                      textAlign: 'center',
                      marginTop: 120,
                      display: 'inherit',
                    }}
                  >
                    <Typography variant="display1" gutterBottom>
                      <span className={classes.myTitle}>
                        {t(
                          'Téléchargez votre rapport et faites un glisser-déplacer ici'
                        )}
                      </span>
                    </Typography>
                  </div>
                  <div className={classes.wrapper}>
                    {loadingReport && (
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />
                    )}
                  </div>
                </Dropzone>
                <div
                  style={{
                    justifyContent: 'left',
                    flexWrap: 'nowrap',
                    alignItems: 'left',
                    marginTop: 20,
                  }}
                >
                  {this.renderReportDetails()}
                </div>
              </div>
            </div>
          </div>
          <div style={{ width: '50%', float: 'left', display: 'inline-block' }}>
            <div
              className={classes.root}
              style={{
                justifyContent: 'center',
                flexWrap: 'nowrap',
                alignItems: 'center',
                alignContent: 'center',
                textAlign: 'center',
                marginTop: 30,
                display: 'inherit',
                height: '100vh',
                padding: 30,
              }}
            >
              <div style={{ width: '100%', clear: 'both' }}>
                <Typography
                  variant="display1"
                  gutterBottom
                  style={{ marginBottom: '2cm' }}
                >
                  <span className={classes.myTitle}>{t('En savoir plus')}</span>
                </Typography>
                <Typography
                  variant="body1"
                  gutterBottom
                  style={{ marginBottom: '1cm' }}
                >
                  <span className={classes.mySubtitle}>
                    {t('Qu’est ce que la blockchain')}
                  </span>
                  <p>
                    Littéralement, une blockchain désigne une chaine de blocs,
                    des conteneurs numériques sur lesquels sont stockés des
                    informations de toutes natures: transactions, contrats,
                    titres de propriétés, œuvres d’art…
                    <br />
                    L’ensemble de ces blocs forme une base de données semblable
                    aux pages d’un grand livre de comptes. Ce livre des comptes
                    est décentralisé ; c’est-à-dire qu’il n’est pas hébergé par
                    un serveur unique mais par une partie des utilisateurs. Les
                    informations contenues sur les blocs sont protégées par
                    plusieurs procédés cryptographiques innovants si bien qu’il
                    est impossible de les modifier a posteriori.
                  </p>
                </Typography>
                <br />
                <Typography variant="body1" gutterBottom>
                  <span className={classes.mySubtitle}>
                    {t(
                      'Comment la blockchain est-elle utilisée pour certifier des documents ou des données?'
                    )}
                  </span>
                  <p>
                    La blockchain joue le rôle de notaire digital : son registre
                    infalsifiable permet de garantir avec certitude quand un
                    document ou une donnée ont été certifiés et qu’il n’ont pas
                    été modifiés depuis.
                    <br />
                    Les documents eux-mêmes ne sont pas directement inscrits sur
                    la blockchain, seule leur empreinte numérique l’est. Cette
                    empreinte numérique (ou hash) du document est obtenue grâce
                    à un algorithme mathématique qui garantit que si le fichier
                    initial ne change que d’un bit du fichier d’origine, le
                    résultat obtenu serait complètement différent. C’est alors
                    cette empreinte numérique qui sera inscrite sur la
                    blockchain.
                    <br />
                    Cette empreinte numérique seule ne permet donc pas de
                    retrouver le fichier initial; c’est l’association du
                    document et de son empreinte digitale inscrite sur la
                    blockchain qui permet d’affirmer qu’un fichier a bien été
                    certifié et par qui.
                  </p>
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ReportCheck.contextTypes = {
  router: PropTypes.object,
};
ReportCheck.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = ({ reportsReducer, router }) => {
  const { loadingReport, currentReport, isReportAuthentic } = reportsReducer;
  const { location } = router;
  return { loadingReport, location, currentReport, isReportAuthentic };
};

const mapDispatchToProps = {
  checkPdfReport,
  resetCheckPdfReport,
};

ReportCheck = withStyles(styles, { name: 'ReportCheck' })(ReportCheck);
ReportCheck = translate('translations')(ReportCheck);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ReportCheck)
);



// WEBPACK FOOTER //
// ./src/components/ReportCheck.js